export default __webpack_public_path__ + "static/flowers-2-b40093f368a6026de158982de1800936.svg";